import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AssessmentService } from 'src/app/services/assessment.service';
import { CourseService } from 'src/app/services/course.service';

@Component({
  selector: 'app-view-assessment',
  templateUrl: './view-assessment.component.html',
  styleUrls: ['./view-assessment.component.scss']
})
export class ViewAssessmentComponent implements OnInit {
  assessmentDetails:any='';
  assessment_id:any='';
  capsuleName:any='';
  backLink:any='';
  tab:any;adminData: any;
  constructor(private auth: AssessmentService,private router: Router,private route: ActivatedRoute, private spinner: NgxSpinnerService,
    private modalService: NgbModal,private toastr: ToastrService,private authCourse:CourseService,private authCours: CourseService,) { }

  ngOnInit(): void {
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.capsuleName = localStorage.getItem('capsuleName');
    this.route.queryParams.subscribe(queryParams => {
    this.assessment_id = queryParams['id'];
      this.assessmentDetail(this.assessment_id);
     });
  }
  logout() {
    // localStorage.clear();
    localStorage.removeItem('adminLoginPass');
    localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
   assessmentDetail(id:any) {
     this.auth.assessmentDetail(id).subscribe(
       data=>{
         this.assessmentDetails = data.data;
       //  localStorage.setItem('assessmentDetails', JSON.stringify(data.data))
         //console.log(data.data);
       },error=>{
         alert(error);
       }
     );
   }
   open(content: any) {
    this.modalService.open(content, { centered: true, size: 'md' });
  }
   changeIsDeActiveVal(is_active: any) {
    this.authCourse.changeIsActiveVal(this.assessment_id, is_active).subscribe(
      (data) => {
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
        //  this.assessmentDetail(this.courseId);
          this.router.navigate(['/view-assessment'], { queryParams: { id: this.assessment_id } });
        } else {
         // this.errorInfo.isError = true;
         // this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        //this.errorInfo.errorMsg = error;
      },
    );
  }
  // duplicateAssessment() {
  //   /*****get couse detail ****/
  //   this.spinner.show();
  //   this.auth.assessmentDetail(this.assessment_id).subscribe(
  //     data => {
  //       this.assessmentDetails = data.data;
  //       this.authCours.dublicateAssessment(this.assessmentDetails).subscribe(
  //         (data) => {
  //           if (this.assessmentDetails.courseModules.length > 0 && data.status == 201) {
             
  //             this.spinner.hide();
  //           } else {
  //             document.getElementById('closelId')?.click();
             
  //             this.spinner.hide();
  //           }
  //         }, error => {
  //           this.spinner.hide();
  //         })
  //     })
  // }
  duplicateAssessment() {
    /*****get couse detail ****/
    this.spinner.show();
    this.auth.assessmentDetail(this.assessment_id).subscribe(
      data => {
        this.assessmentDetails = data.data;
        this.authCours.dublicateAssessment(this.assessmentDetails).subscribe(
          (data) => {
            if (data.status == 201) {
              document.getElementById('closelId')?.click();
              this.router.navigate(['/manage-assessments'], { queryParams: { tab: '2' } });
              this.spinner.hide();
            }
          }, error => {
            this.spinner.hide();
          })
      })
  }
}
